import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Header from './Header';
import Table from './Table';
import Pagination from './Pagination';

export default inject('root')(
  observer(({ root }) => {
    const { oceanCarriers, loadOceanCarriers, loading, pagination } = root.oceanCarriers;

    useEffect(() => {
      loadOceanCarriers();
    }, []);

    return (
      <>
        <Header />
        <Table
          loading={loading}
          oceanCarriers={oceanCarriers}
        />
         <Pagination pagination={pagination} />
      </>
    );
  })
)
